"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BucketAlreadyExists = {
    type: "structure",
    required: [],
    members: {},
    exceptionType: "BucketAlreadyExists"
};
//# sourceMappingURL=BucketAlreadyExists.js.map